import { RouteObject } from "react-router";

/**
 *  Setup routes for payment process including paying onscreen & requesting payment
 *
 * '/(jobs|orgs|)/:id/(presentations|images|documents|estimateTemplates)/*'
 *
 * @returns {RouteObject[]} Array of payment routes
 */
export const setupMakePaymentRoutes = (): RouteObject[] => {
  return [
    {
      path: "payment/onscreen",
      shouldRevalidate: () => false,
      async loader(args) {
        const { startPaymentProcessLoader } = await import("src/router/loaders/common/MakePayment");
        return startPaymentProcessLoader(args);
      },
      async lazy() {
        const { OnscreenModal } = await import("jobs/common/PaymentModal/OnscreenModal");
        return {
          element: <OnscreenModal />,
        };
      },
    },
    {
      path: "payment/request",
      async loader(args) {
        const { authorizedPaymentsLoader } = await import("src/router/loaders/common/MakePayment");
        return authorizedPaymentsLoader(args);
      },
      async lazy() {
        const { RequestModal } = await import("jobs/common/PaymentModal/RequestModal");
        return {
          element: <RequestModal />,
        };
      },
    },
    {
      path: "payment/save_method",
      async loader(args) {
        const { saveMethodLoader } = await import("src/router/loaders/common/MakePayment");
        return saveMethodLoader(args);
      },
      async lazy() {
        const { SaveMethodModal } = await import("jobs/common/PaymentModal/SaveMethodModal");
        return {
          element: <SaveMethodModal />,
        };
      },
    },
    {
      path: "payment/result/:paymentId",
      async loader(args) {
        const { withCachingPaymentLoader } = await import("src/router/loaders/common/MakePayment");
        return withCachingPaymentLoader(args);
      },
      async lazy() {
        const { ResultModal } = await import("jobs/common/PaymentModal/ResultModal");
        return {
          element: <ResultModal />,
        };
      },
    },
  ];
};
